import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { TipoPagamentoEcgTerceiro } from 'src/app/model/tipo-pagamento-ecg-terceiro';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

export const LIMITE_OPERACOES_EXPORTADAS = 5000;

@Injectable({
  providedIn: 'root'
})
export class TipoPagamentoEcgTerceiroService extends FgiBackEndService<TipoPagamentoEcgTerceiro> {

  getNewEntity(): TipoPagamentoEcgTerceiro {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tipo-pagamento-terceiro';
  }

  public listarTodos(): Observable<TipoPagamentoEcgTerceiro[]> {
    const options: any = blockUi();
    return this.http.get<TipoPagamentoEcgTerceiro[]>(`${this.BASE_URL}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>
  }

 public salvarTipoPagamentoEcgTerceiro(tipoPagamentoEcgTerceiro: TipoPagamentoEcgTerceiro) {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/salvar`, tipoPagamentoEcgTerceiro, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public salvarEdicaoTipoPagamentoEcgTerceiro(tipoPagamentoEcgTerceiro: TipoPagamentoEcgTerceiro) {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/salvar/edicao`, tipoPagamentoEcgTerceiro, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarFiltradoTipoPagamentoEcgTerceiro(params?: any){
    const options: any = blockUi();
    options.params = params;
    return this.http.get<TipoPagamentoEcgTerceiro[]>(`${this.BASE_URL}/ecg-terceiros-filtrados`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarDadosEdicaoVisualizacao(ideEcgTerceiro: number){
    const options: any = blockUi();
    return this.http.get<TipoPagamentoEcgTerceiro>(`${this.BASE_URL}/${ideEcgTerceiro}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

   public excluirTipoPagamentoEcgTerceiro(idTipoPagamentoEcgTerceiro: number): Observable<void> {
        const options = blockUi();
      return this.http.post(`${this.BASE_URL}/excluir/${idTipoPagamentoEcgTerceiro}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<void>;
  }


}
